// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"4fa7c5ac","496":"f1a96aa3"}[chunkId] + ".chunk.js";
};